<template>
  <span class="typo_text">
    {{ typeValue }}
    <span class="cursor" :class="{'typing': typeStatus}">&nbsp;</span>
  </span>

</template>

<script>
import {setTimeout} from "timers";

export default {
  name: "TheTypo",
  data: () => {
    return {
      typeArray: ['Developer','Software Engineer'],
      typeValue: '',
      typeStatus: false,
      typingSpeed: 100,
      erasingSpeed: 50,
      newTextDelay: 2000,
      typeArrayIndex: 0,
      charIndex: 0
    }
  },
  methods: {
    typeText() {
      if(this.charIndex < this.typeArray[this.typeArrayIndex].length) {
        if(!this.typeStatus)
          this.typeStatus = true;
        this.typeValue += this.typeArray[this.typeArrayIndex].charAt(this.charIndex);
        this.charIndex += 1;
        setTimeout(this.typeText, this.typingSpeed);
      }
      else {
        this.typeStatus = false;
        setTimeout(this.eraseText, this.newTextDelay);
      }
    },
    eraseText() {
      if(this.charIndex > 0) {
        if(!this.typeStatus)
          this.typeStatus = true;
        this.typeValue = this.typeArray[this.typeArrayIndex].substring(0, this.charIndex - 1);
        this.charIndex -= 1;
        setTimeout(this.eraseText, this.erasingSpeed);
      }
      else {
        this.typeStatus = false;
        this.typeArrayIndex += 1;
        if(this.typeArrayIndex >= this.typeArray.length)
          this.typeArrayIndex = 0;
        setTimeout(this.typeText, this.typingSpeed + 1000);
      }
    }
  },
  created() {
    this.typeText();
  }
}
</script>

<style scoped>
  span.cursor {
    display: inline-block;
    margin-left: -5px;
    width: 4px;
    background-color: #fff;
    animation: cursorBlink 1s infinite;
  }


  @keyframes cursorBlink {
    49% { background-color: #fff; }
    50% { background-color: transparent; }
    99% { background-color: transparent; }
  }
</style>